import React from 'react';

import './FormInput.css';

const FormInput = (props) => {
  return <input {...props} />;
};

export default FormInput;
